import { render, staticRenderFns } from "./rating-rollback-modal.vue?vue&type=template&id=482c7b87&"
import script from "./rating-rollback-modal.vue?vue&type=script&lang=js&"
export * from "./rating-rollback-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports